import axios from "axios";
import router from "../router";
import { BrowserClient, Hub, Severity } from "@sentry/browser";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 100000
});

const log = new BrowserClient({
  dsn: process.env.VUE_APP_SENTRY_URL,
  environment: process.env.NODE_ENV
});

httpClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    error.message = error.config.url + ": " + error.message;
    const hub = new Hub(log);
    hub.addBreadcrumb({
      category: "xhr",
      message: `${error.config.method} ${error.config.url}: ${
        (error.response || {}).data
      }`,
      level: Severity.Info
    });

    hub.captureException(error);

    let isResource = error.config.url.indexOf("resource") >= 0;
    if (error.response.status == 409) {
      router.push("/surveycomplete");
    } else if (error.response.status == 401) {
      if (isResource) {
        router.push("/resourceunavailable");
      } else {
        router.push("/surveyinvalid");
      }
    } else {
      router.push("/error");
    }
    return Promise.reject(error);
  }
);

export default httpClient;
